let thermalData = [
  {name:'TNC225R',series:'ThermNight',price:'$1329.99',
    img:'https://us.dntoptics.com/cdn/shop/files/TNC225R_-_Thermal_Night_Vision_Multi-spectum_Scope_with_Laser_Rangefinder_and_Ballistic_Calculator-1-A.jpg?v=1718603936',
    url:'https://us.dntoptics.com/products/tnc225r-thermnight-thermal-night-vision-multi-spectral-scope-with-laser-rangefinder-and-ballistic-calculator'
  },
  {name:'TNC335R',series:'ThermNight',price:'$2199.99',
    img:'https://us.dntoptics.com/cdn/shop/files/TNC335R-ThermNight-Thermal_Night-Vision-Multispectral-Scope1.jpg?v=1731997769',
    url:'https://us.dntoptics.com/products/tnc335r-thermnight-thermal-night-vision-multispectral-scope-with-laser-rangefinder-and-ballistic-calculator'
  },
  {name:'TNC635R',series:'ThermNight',price:'$3159.99',
    img:'https://us.dntoptics.com/cdn/shop/files/TNC635R-ThermNight-Thermal_Night-Vision-Multispectral-Scope1.jpg?v=1731997968',
    url:'https://us.dntoptics.com/products/tnc635r-thermnight-thermal-night-vision-multispectral-scope-with-laser-rangefinder-and-ballistic-calculator'
  },
  {name:'HS225',series:'Hydra',price:'$887.99',
    img:'https://us.dntoptics.com/cdn/shop/files/HS225_1.jpg?v=1732262553',
    url:'https://us.dntoptics.com/products/hs225-hydra-256x192-25mm-multi-function-thermal-scope-standalone-scope-clip-on-handheld-monocular'
  },
  {name:'HS325',series:'Hydra',price:'$1332.99',
    img:'https://us.dntoptics.com/cdn/shop/files/HS325_1.jpg?v=1732263025',
    url:'https://us.dntoptics.com/products/hs325-hydra-384x288-25mm-multi-function-thermal-scope-standalone-scope-clip-on-handheld-monocular'
  },
  {name:'HS635',series:'Hydra',price:'$2221.99',
    img:'https://us.dntoptics.com/cdn/shop/files/HS635_1.jpg?v=1732263121',
    url:'https://us.dntoptics.com/products/hs635-hydra-640x512-35mm-multi-function-thermal-scope-standalone-scope-clip-on-handheld-monocular'
  },
  {name:'HS219',series:'Hydra',price:'$776.99',
    img:'https://mmykg4ij91v36m7a-70667763947.shopifypreview.com/cdn/shop/files/HS219_9.jpg?v=1757580853',
    url:'https://us.dntoptics.com/products/hs219-hydra-256x192-19mm-multi-function-thermal-scope-standalone-scope-clip-on-handheld-monocular'
  },
  {name:'HS335',series:'Hydra',price:'$1554.99',
    img:'https://iqangmw34lg0vybd-70667763947.shopifypreview.com/cdn/shop/files/HS335-5.jpg?v=1757581132',
    url:'https://us.dntoptics.com/products/hs335-hydra-384x288-35mm-multi-function-thermal-scope-standalone-scope-clip-on-handheld-monocular'
  },

  {name:'HS650',series:'Hydra',price:'$2665.99',
    img:'https://us.dntoptics.com/cdn/shop/files/HS650-HYDRA-640x512-50mmMulti-FunctionThermalScope-01.jpg?v=1760083980',
    url:'https://us.dntoptics.com/products/hs650-hydra-640-512-50mm-multi-function-thermal-scope-standalone-scope-clip-on-handheld-monocular'
  },
  {name:'HS225R',series:'Hydra',price:'$1110.99',
    img:'https://us.dntoptics.com/cdn/shop/files/HS225R-HYDRA-256x192-25mm-Multi-Function-Thermal-Scope-01.jpg?v=1760068844',
    url:'https://us.dntoptics.com/products/hs225r-hydra-lrf-multi-function-thermal-scope-with-laser-rangefinder-and-ballistic-calculator-standalone-scope-clip-on-handheld-monocular'
  },
  {name:'HS335R',series:'Hydra',price:'$1776.99',
    img:'https://us.dntoptics.com/cdn/shop/files/HS335R-HYDRA-LRF-384x288-35mm-Multi-Function-Thermal-Scope-01.jpg?v=1760068954',
    url:'https://us.dntoptics.com/products/hs335r-hydra-lrf-multi-function-thermal-scope-with-laser-rangefinder-and-ballistic-calculator-standalone-scope-clip-on-handheld-monocular'
  },
  {name:'HS635R',series:'Hydra',price:'$2443.99',
    img:'https://us.dntoptics.com/cdn/shop/files/HS635R-HYDRA-LRF-640x512-35mm-Multi-Function-Thermal-Scope-01.jpg?v=1760069637',
    url:'https://us.dntoptics.com/products/hs635r-hydra-lrf-multi-function-thermal-scope-with-laser-rangefinder-and-ballistic-calculator-standalone-scope-clip-on-handheld-monocular'
  },
  {name:'HS650R',series:'Hydra',price:'$2887.99',
    img:'https://us.dntoptics.com/cdn/shop/files/HS635R-HYDRA-LRF-640x512-50mm-Multi-Function-Thermal-Scope-01_5b493a49-d1a3-4d6a-94ab-fc5f4bab415a.jpg?v=1760080057',
    url:'https://us.dntoptics.com/products/hs650r-hydra-lrf-multi-function-thermal-scope-with-laser-rangefinder-and-ballistic-calculator-standalone-scope-clip-on-handheld-monocular'
  },

]
let NightVisionData = [
  {name:'ZHD312R',series:'ZULUS HD',price:'$615.99',
    img:'https://us.dntoptics.com/cdn/shop/files/ZHD312R-ZULUSHD3-12XDigitalNightVisionScopewithLaserRangefinderandBallisticCalculator-1.jpg?v=1718605978',
    url:'https://us.dntoptics.com/products/zhd312r-zulus-hd-3-12x-digital-night-vision-scope-with-laser-rangefinder-and-ballistic-calculator'
  },

  {name:'ZHD520R-V2',series:'ZULUS HD V2',price:'$776.99',
    img:'https://us.dntoptics.com/cdn/shop/files/ZHD520R-V2_Front_view-PMS.jpg?v=1751428069',
    url:'https://us.dntoptics.com/products/zhd520r-v2-zulus-hd-v2-5-20x-digital-night-vision-scope-with-laser-rangefinder-and-ballistic-calculator'
  },
  {name:'ZHD312R-V2',series:'ZULUS HD V2',price:'$776.99',
    img:'https://us.dntoptics.com/cdn/shop/files/ZHD312R-V2_Front_view-PMS.jpg?v=1751428063',
    url:'https://us.dntoptics.com/products/zhd312r-v2-zulus-hd-v2-3-12x-digital-night-vision-scope-with-laser-rangefinder-and-ballistic-calculator'
  },
  {name:'ZHD312-V2',series:'ZULUS HD V2',price:'$554.99',
    img:'https://k8552jn8mry71qq9-70667763947.shopifypreview.com/cdn/shop/files/ZHD312-V2-pms.jpg?v=1754300897',
    url:'https://us.dntoptics.com/products/zhd312-v2-zulus-hd-v2-3-12x-digital-night-vision-scope'
  },
  {name:'ZHD520-V2',series:'ZULUS HD V2',price:'$554.99',
    img:'https://k8552jn8mry71qq9-70667763947.shopifypreview.com/cdn/shop/files/ZHD520-V2-pms.jpg?v=1754300804',
    url:'https://us.dntoptics.com/products/zhd520-v2-zulus-hd-v2-5-20x-digital-night-vision-scope'
  },
  {name:'NVMD-C200',series:'NVMD',price:'$776.99',
    img:'https://us.dntoptics.com/cdn/shop/files/NVMD-C200-01.jpg?v=1760510231',
    url:'https://us.dntoptics.com/products/nvmd-c200-night-vision-multi-purpose-device-red-dot-magnifier-standalone-scope-clip-on-action-camera'
  }
]
let HoundData = [
  {name:'H315R',series:'HOUND',price:'$1099.99',
    img:'https://ormcms33pww6u3pg-70667763947.shopifypreview.com/cdn/shop/files/H315R-HoundThermalImagingMonocular-2.jpg?v=1756192799',
    url:'https://us.dntoptics.com/products/h315r-hound-thermal-imaging-monocular-with-laser-rangefinder-and-ballistic-calculator'
  },
  {name:'H325R',series:'HOUND',price:'$1325.99',
    img:'https://ormcms33pww6u3pg-70667763947.shopifypreview.com/cdn/shop/files/H325R-HoundThermalImagingMonocular-2.jpg?v=1756193206',
    url:'https://us.dntoptics.com/products/h325r-hound-thermal-imaging-monocular-with-laser-rangefinder-and-ballistic-calculator'
  },
  {name:'H635R',series:'HOUND',price:'$2099.99',
    img:'https://ormcms33pww6u3pg-70667763947.shopifypreview.com/cdn/shop/files/H635R-HoundThermalImagingMonocular-2.jpg?v=1756193275',
    url:'https://us.dntoptics.com/products/h635r-hound-thermal-imaging-monocular-with-laser-rangefinder-and-ballistic-calculator'
  }
]
var rowHeadList =[
  {headName:'Thermal Sensor Specifications',rowList:['Resolution','Image Sensor','Pixel Size','Frame Rate','NETD','Objective Lens Focal Length','Base Magnification','Digital Magnification','Field of View(HxV)'],
    paramData:[]
  },
  {headName:'Digital Day/Night Vision Sensor Specifications',rowList:['Frame Rate','Resolution','Video Record Resolution'],
    paramData:[]
  },
  {headName:'Display Specifications',rowList:['Type','Display Resolution','Frame Rate'],
    paramData:[]
  },
  {headName:'Optical Specifications',rowList:['Base Magnification','Digital Magnification','Field of View(HxV)','Eye Relief','Diopter Adjustment','IR Wavelength','IR Rating','Detection Range'],
    paramData:[]
  },
  {headName:'Battery Power Supply',rowList:['Battery Type','Operating Time','External Power Supply'],
    paramData:[]
  },
  { headName:'Physical Specifications',rowList:['Net Weight','Dimensions','Memory','IP Waterproof','WIFI/APP','Operation Distance','Operating Temperature','Recoil Rating'],
    paramData:[]
  }
]


const urlParams = new URLSearchParams(window.location.search);
let seriesType = urlParams.get('seriesType');
let curentModel = urlParams.get('curentModel');

if(seriesType == null & curentModel == null){
  seriesType = 'ThermNight';
  curentModel = 'TNC635R'
}

const currentSeries = seriesType
var currentSeriesData = []
if(currentSeries == 'ThermNight' || currentSeries == 'Hydra' || currentSeries == 'HydraLRF'){
  currentSeriesData = thermalData
}else if(currentSeries == 'ZULUS-V1' || currentSeries == 'ZULUS-V2'|| currentSeries == 'NVMD'){
  currentSeriesData = NightVisionData
  rowHeadList.shift()
}else if(currentSeries == 'HOUND'){
  currentSeriesData = HoundData
  rowHeadList = rowHeadList.filter( obj => obj.headName != 'Digital Day/Night Vision Sensor Specifications' && obj.headName != 'Optical Specifications')
}

var globalChooseData = []

let chooseBuffer = []
const currentTag = curentModel.split(',')
console.log('接受参数',currentTag)
console.log('当前商品组',currentSeriesData)
currentSeriesData.map( obj => {
  currentTag.map( obj2 => {
    if(obj.name == obj2){
      console.log('符合条件')
      chooseBuffer.push(obj)
    }
  })
})

//为了保持传参顺序一致
currentTag.map( obj => {
  chooseBuffer.map( item => {
    if(item.name == obj ){
      globalChooseData.push(item)
    }
  })
})

// var globalChooseData = currentSeriesData.filter( item => item.name == currentTag)


const seriesParams = [
  {name:'TNC225R',physicalParams:['22.8oz','6.7x3.3x3.1 inches','Bulit-in memory,32GB','IP67','YES(DNT)','5-1100yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','5h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1024x768 pixels'],
                  OpticalSpecifications:['5x','5～20x','10.7yd@100yd x 6.0yd@100yd','45mm','±5D','850/940nm','Class 3R Eye Safe','400m'],
                  ThermalSensorSpecifications:['256x192 pixels','Uncooled infrared sensor','12x12um','50FPS','≤25mk @25℃','25mm','3x','3-12x','12.3yd@100yd x 9.2yd@100yd']
  },
  {name:'TNC335R',physicalParams:['25.6oz','9.2x3.2x3.0 inches','Bulit-in memory,64GB','IP67','YES(DNT)','5-1200yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','60Hz'],
                  BatteryPowered:['21700 Battery(flat top)','6h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1800x1080 pixels'],
                  OpticalSpecifications:['5x','5～20x','9.3yd@100yd x 5.2yd@100yd','65mm','±3D','850/940nm','Class 3R Eye Safe','400m'],
                  ThermalSensorSpecifications:['384x288 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','35mm','2.5x','2.5-10x','13.2yd@100yd x 9.9yd@100yd']
  },
  {name:'TNC635R',physicalParams:['25.6oz','9.2x3.2x3.0 inches','Bulit-in memory,64GB','IP67','YES(DNT)','5-1200yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','60Hz'],
                  BatteryPowered:['21700 Battery(flat top)','5.5h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1800x1080 pixels'],
                  OpticalSpecifications:['5x','5～20x','9.3yd@100yd x 5.2yd@100yd','65mm','±3D','850/940nm','Class 3R Eye Safe','400m'],
                  ThermalSensorSpecifications:['640x512 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','35mm','1.5x','1.5-6x','21.9yd@100yd x 17.6yd@100yd']
  },
  {name:'HS225',physicalParams:['13.1oz','8.0x2.7x2.0 inches','Bulit-in memory,32GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','5.5h','5V Type-C USB'],
                  DigitalSensorSpecifications:['/','/','/'],
                  OpticalSpecifications:['/','/','/','/','/','/','/','/'],
                  ThermalSensorSpecifications:['256x192 pixels','Uncooled infrared sensor','12x12um','50FPS','≤25mk @25℃','25mm','3x','3-12x','12.3yd@100yd x 9.2yd@100yd']
  },
  {name:'HS325',physicalParams:['13.4oz','8.0x2.7x2.0 inches','Bulit-in memory,32GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','4.5h','5V Type-C USB'],
                  DigitalSensorSpecifications:['/','/','/'],
                  OpticalSpecifications:['/','/','/','/','/','/','/','/'],
                  ThermalSensorSpecifications:['384x288 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','25mm','2x','2-8x','18.4yd@100yd x 13.8yd@100yd']
  },
  {name:'HS635',physicalParams:['13.7oz','7.9x2.7x2.0 inches','Bulit-in memory,32GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','4h','5V Type-C USB'],
                  DigitalSensorSpecifications:['/','/','/'],
                  OpticalSpecifications:['/','/','/','/','/','/','/','/'],
                  ThermalSensorSpecifications:['640x512 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','35mm','1.5x','1.5-6x','21.9yd@100yd x 17.6yd@100yd']
  },
  {name:'HS219',physicalParams:['13.2oz','8.0x2.7x2.0 inches','Bulit-in memory,32GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','5.5h','5V Type-C USB'],
                  DigitalSensorSpecifications:['/','/','/'],
                  OpticalSpecifications:['/','/','/','/','/','/','/','/'],
                  ThermalSensorSpecifications:['256x192 pixels','Uncooled infrared sensor','12x12um','50FPS','≤25mk @25℃','19mm','2x','2-8x','16.2yd@100yd x 12.1yd@100yd']
  },
  {name:'HS335',physicalParams:['13.7oz','7.8x2.7x2.0 inches','Bulit-in memory,32GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','4.5h','5V Type-C USB'],
                  DigitalSensorSpecifications:['/','/','/'],
                  OpticalSpecifications:['/','/','/','/','/','/','/','/'],
                  ThermalSensorSpecifications:['384x288 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','35mm','3x','3-12x','13.2yd@100yd x 9.9yd@100yd']
  },





  {name:'HS650',physicalParams:['16.9oz','8.4x2.7x2.2 inches','Bulit-in memory,32GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','4h','5V Type-C USB'],
                  DigitalSensorSpecifications:['/','/','/'],
                  OpticalSpecifications:['/','/','/','/','/','/','/','/'],
                  ThermalSensorSpecifications:['640x512 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','50mm','2.5x','2.5-10x','15.4yd@100yd x 11.5yd@100yd']
  },
  {name:'HS225R',physicalParams:['14.4oz','8.0x2.7x2.0 inches','Bulit-in memory,32GB','IP67','YES(DNT)','5-1200yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','5.5h','5V Type-C USB'],
                  DigitalSensorSpecifications:['/','/','/'],
                  OpticalSpecifications:['/','/','/','/','/','/','/','/'],
                  ThermalSensorSpecifications:['256x192 pixels','Uncooled infrared sensor','12x12um','50FPS','≤25mk @25℃','25mm','3x','3-12x','12.3yd@100yd x 9.2yd@100yd']
  },
  {name:'HS335R',physicalParams:['15.0oz','7.8x2.7x2.0 inches','Bulit-in memory,32GB','IP67','YES(DNT)','5-1300yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','4.5h','5V Type-C USB'],
                  DigitalSensorSpecifications:['/','/','/'],
                  OpticalSpecifications:['/','/','/','/','/','/','/','/'],
                  ThermalSensorSpecifications:['384x288 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','35mm','3x','3-12x','13.2yd@100yd x 9.9yd@100yd']
  },
  {name:'HS635R',physicalParams:['15.0oz','7.9x2.7x2.0 inches','Bulit-in memory,32GB','IP67','YES(DNT)','5-1300yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','4h','5V Type-C USB'],
                  DigitalSensorSpecifications:['/','/','/'],
                  OpticalSpecifications:['/','/','/','/','/','/','/','/'],
                  ThermalSensorSpecifications:['640x512 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','35mm','1.5x','1.5-6x','21.9yd@100yd x 17.6yd@100yd']
  },
  {name:'HS650R',physicalParams:['18.2oz','8.4x2.7x2.2 inches','Bulit-in memory,32GB','IP67','YES(DNT)','5-1300yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','4h','5V Type-C USB'],
                  DigitalSensorSpecifications:['/','/','/'],
                  OpticalSpecifications:['/','/','/','/','/','/','/','/'],
                  ThermalSensorSpecifications:['640x512 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','50mm','2.5x','2.5-10x','15.4yd@100yd x 11.5yd@100yd']
  },




  {name:'ZHD312',physicalParams:['14.0oz','6.1x3.0x1.9 inches','Micro SD Card 32～128(U1/C10)GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','60Hz'],
                  BatteryPowered:['18650 Battery(flat top)','8h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1920x1080 pixels'],
                  OpticalSpecifications:['3x','3～12x','13.9yd@100yd x 7.8yd@100yd','45mm','±5D','850nm','Class 3R Eye Safe','400m']
  },
  {name:'ZHD312R',physicalParams:['16.4oz','6.1x3.1x2.2 inches','Micro SD Card 32～128(U1/C10)GB','IP67','YES(DNT)','5-1100yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','60Hz'],
                  BatteryPowered:['18650 Battery(flat top)','8h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1920x1080 pixels'],
                  OpticalSpecifications:['3x','3～12x','13.9yd@100yd x 7.8yd@100yd','45mm','±5D','850/940nm','Class 3R Eye Safe','400m']
  },
  {name:'ZHD520',physicalParams:['14.8oz','6.5x3.0x2.0 inches','Micro SD Card 32～128(U1/C10)GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','60Hz'],
                  BatteryPowered:['18650 Battery(flat top)','8h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1920x1080 pixels'],
                  OpticalSpecifications:['5x','5～20x','8.6yd@100yd x 4.8yd@100yd','45mm','±5D','850nm','Class 3R Eye Safe','400m']
  },
  {name:'ZHD520R',physicalParams:['17.0oz','6.5x3.1x2.1 inches','Micro SD Card 32～128(U1/C10)GB','IP67','YES(DNT)','5-1100yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','60Hz'],
                  BatteryPowered:['18650 Battery(flat top)','8h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1920x1080 pixels'],
                  OpticalSpecifications:['5x','5～20x','8.6yd@100yd x 4.8yd@100yd','45mm','±5D','850/940nm','Class 3R Eye Safe','400m']
  },
  {name:'ZHD312R-V2',physicalParams:['18.4oz','6.0x3.0x2.1 inches','Bulit-in memory,32GB','IP67','YES(DNT)','5-1100yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','60Hz'],
                  BatteryPowered:['21700 Battery(flat top)','10h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1800x1080 pixels'],
                  OpticalSpecifications:['3x','3～12x','13.9yd@100yd x 7.8yd@100yd','65mm','±3D','850/940nm','Class 3R Eye Safe','400m']
  },
  {name:'ZHD520R-V2',physicalParams:['19.1oz','6.4x3.0x2.1 inches','Bulit-in memory,32GB','IP67','YES(DNT)','5-1100yds','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','60Hz'],
                  BatteryPowered:['21700 Battery(flat top)','10h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1800x1080 pixels'],
                  OpticalSpecifications:['5x','5～20x','8.6yd@100yd x 4.8yd@100yd','65mm','±3D','850/940nm','Class 3R Eye Safe','400m']
  },
  {name:'ZHD312-V2',physicalParams:['16.3oz','6.0x2.9x2.0 inches','Bulit-in memory,32GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','60Hz'],
                  BatteryPowered:['21700 Battery(flat top)','10h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1800x1080 pixels'],
                  OpticalSpecifications:['3x','3～12x','13.9yd@100yd x 7.8yd@100yd','65mm','±3D','850/940nm','Class 3R Eye Safe','400m']
  },
  {name:'ZHD520-V2',physicalParams:['17.0oz','6.4x2.9x2.0 inches','Bulit-in memory,32GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','60Hz'],
                  BatteryPowered:['21700 Battery(flat top)','10h','5V Type-C USB'],
                  DigitalSensorSpecifications:['60Hz','1920x1080 pixels','1800x1080 pixels'],
                  OpticalSpecifications:['5x','5～20x','8.6yd@100yd x 4.8yd@100yd','65mm','±3D','850/940nm','Class 3R Eye Safe','400m']
  },
  {name:'NVMD-C200',physicalParams:['13.8oz','3.9x2.9x2.5 inches','Bulit-in memory,32GB','IP67','YES(DNT)','/','-4～122℉','.50BMG'],
                  displayParams:['micro-OLED','1920x1080 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','6h','5V Type-C USB'],
                  DigitalSensorSpecifications:['50Hz','1920x1080 pixels','1800x1080 pixels'],
                  OpticalSpecifications:['1x','1～6x','48yd@100yd x 27yd@100yd','65mm','±2D','/','/','/']
  },

  {name:'H315R',physicalParams:['10.16oz','6.1x1.9x2.8 inches','Bulit-in memory,32GB','IP67','YES(DNT)','5-1200yds','-4～122℉','/'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','5.5h','5V Type-C USB'],
                  ThermalSensorSpecifications:['384x288 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','15mm','1.5x','1.5-6x','30.7yd@100yd x 23.0yd@100yd']
  },
  {name:'H325R',physicalParams:['10.55oz','6.1x1.9x2.8 inches','Bulit-in memory,32GB','IP67','YES(DNT)','5-1200yds','-4～122℉','/'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','5.5h','5V Type-C USB'],
                  ThermalSensorSpecifications:['384x288 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','25mm','2.5x','2.5-10x','18.4yd@100yd x 13.8yd@100yd']
  },
  {name:'H635R',physicalParams:['10.93oz','6.2x2.0x2.8 inches','Bulit-in memory,32GB','IP67','YES(DNT)','5-1200yds','-4～122℉','/'],
                  displayParams:['micro-OLED','1024x768 pixels','50Hz'],
                  BatteryPowered:['18650 Battery(flat top)','5.5h','5V Type-C USB'],
                  ThermalSensorSpecifications:['640x512 pixels','Uncooled infrared sensor','12x12um','50FPS','≤18mk @25℃','35mm','2x','2-8x','21.9yd@100yd x 17.6yd@100yd']
  },
]


currentTag.map( item => {
     const currentParams = seriesParams.find( obj => obj.name == item)
     rowHeadList.map( obj => {
        let pushArr = []
        if(obj.headName == 'Physical Specifications'){
          pushArr = [{ name:item,data:currentParams.physicalParams }]
        }else if(obj.headName == 'Display Specifications'){
          pushArr = [{ name:item,data:currentParams.displayParams }]
        }else if(obj.headName == 'Battery Power Supply'){
          pushArr = [{ name:item,data:currentParams.BatteryPowered }]
        }else if(obj.headName == 'Digital Day/Night Vision Sensor Specifications'){
          pushArr = [{ name:item,data:currentParams.DigitalSensorSpecifications }]
        }else if(obj.headName == 'Optical Specifications'){
          pushArr = [{ name:item,data:currentParams.OpticalSpecifications }]
        }else if(obj.headName == 'Thermal Sensor Specifications'){
          pushArr = [{ name:item,data:currentParams.ThermalSensorSpecifications }]
        }
        obj.paramData = [...obj.paramData,...pushArr]
    })
})